import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import getImageUrl from '../../../utils/getImageUrl';
import Video from '../../../models/video';

const RATIO = 16/9;

class VideoFeedView extends Component {
  static propTypes = {
    video: PropTypes.instanceOf(Video).isRequired
  };

  constructor() {
    super();

    this.calculateSize = this.calculateSize.bind(this);
    this.handlePlayButtonClicked = this.handlePlayButtonClicked.bind(this);
    this.state = {
      isPlaying: false,
      containerWidth: 520,
      containerHeight: 520 / RATIO
    };
  }

  componentDidMount() {
    this.calculateSize();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.calculateSize);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.calculateSize)
    }
  }

  calculateSize() {
    const container = findDOMNode(this.refs.containers).parentNode;
    const containerRect = container.getBoundingClientRect();

    this.setState({
      containerWidth: containerRect.width,
      containerHeight: containerRect.width / RATIO
    });
  }

  handlePlayButtonClicked() {
    this.setState({
      isPlaying: true
    });
  }

  render() {
    const { video } = this.props;
    const { isPlaying, containerWidth, containerHeight } = this.state;

    const containerStyle = {
      width: containerWidth,
      height: containerHeight
    };

    const thumbnailStyle = {
      width: 'auto',
      height: containerHeight
    };

    const isLive = video.get('liveLinkId', 0) > 0;
    const playPath = (video.get('playUrl').includes('sandbox') ? 'https://sandbox-tv.kakao.com' : 'https://tv.kakao.com') + '/embed/player';
    const videoSrc = `${playPath}/${(!video.get('clipLinkId') || video.get('clipLinkId') === 0) ? 'livelink/'.concat(video.get('liveLinkId'))
      : 'cliplink/'.concat(video.get('clipLinkId'))}?service=kakao_talkplus&play_loc=kakao_talkplus&autoplay=true`;

    if (isPlaying) {
      return (
        <div className="post_card">
          <div className="card_default card_vod">
            <a href="#" className="link_card" ref="containers" style={{ height: 'auto' }}>
              <div id="videoPlayer" className="wrap_thumb" style={containerStyle}>
                <iframe
                  title={video.name}
                  style={containerStyle}
                  src={videoSrc}
                  frameBorder="0"
                  scrolling="no"
                  allowFullScreen
                />
              </div>
            </a>
          </div>
        </div>
      );
    }

    return (
      <div className="post_card">
        <div className="card_default card_vod">
          <a href="#" className="link_card" ref="containers" onClick={(e) => e.preventDefault()} style={{ height: 'auto' }}>
            <div className="wrap_thumb" style={containerStyle}>
              <img src={getImageUrl(video.thumbnail)} className="img_thumb" alt={video.name}
                style={thumbnailStyle}
              />
                <span className="frame_g" />
            </div>
            { isLive && <span className="ico_plus ico_live">LIVE</span> }
            <span className="ico_plus ico_play" onClick={this.handlePlayButtonClicked}>Play</span>
          </a>
        </div>
      </div>
    );
  }
}

export default VideoFeedView;



// WEBPACK FOOTER //
// ./src/components/PostBox/FeedView/VideoFeedView.js